import React from 'react'
import compose from 'recompose/compose'
import moment from 'moment'
import _ from 'lodash'
import {withI18n} from '../../hocs'
import PropTypes from 'prop-types'
import * as S from './styled'
import ActionDialog from '../action-dialog'
import {CheckButton} from '../../atoms'
import Tag from "../../atoms/tag";

const ModalChangeTags = ({ open, handleClose, i18n, tagsTypes, currentTags, onSubmit }) => {
  const tagsTypesCopy = _.cloneDeep(tagsTypes)
  tagsTypesCopy.forEach((tag) => {
    if (_.find(currentTags, {id: tag.id})) {
      tag.enabled=true
    } else {
      tag.enabled=false
    }
  })
  const [tagsTypesState, setTagsTypesState] = React.useState(tagsTypesCopy)
  const [date] = React.useState(new Date())

  const reset = () => {
    tagsTypesState.forEach((tag) => {
      tag.enabled=false
    })
  }

  const onClickSubmit = (e) => {
    e && e.preventDefault()
    const tagsRes = tagsTypesState.filter(tag => tag.enabled === true).map(tag => tag.id)

    // Devuelve la petición del padre: ActionDialog mantiene el spinner hasta que responde
    return Promise.resolve(onSubmit(tagsRes, moment(date).format('YYYY-MM-DD HH:mm:ss'))).then(reset)
  }

  const toggle = (tag) => {
    tag.enabled = !tag.enabled
    setTagsTypesState(_.cloneDeep(tagsTypesState))
  }

  return (
    <ActionDialog
      open={open}
      title={i18n.modalChangeTags.title}
      onClose={handleClose}
      onConfirm={onClickSubmit}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={i18n.update}
    >
      <S.TagList>
        {
          tagsTypesState.map(tag => {
            return (
              <div className="tag-row" key={`mcr_${tag.id}`}>
                <Tag shortVersion={ false } tag={tag} onClick={() => toggle(tag)}/>
                <CheckButton
                  name={"tag-"+tag.id}
                  title={i18n.modalCreateReport.include}
                  checked={tag.enabled}
                  onChange={() => toggle(tag)}
                />
              </div>
            )
          })
        }
      </S.TagList>
    </ActionDialog>
  )
}

ModalChangeTags.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  tagsTypes: PropTypes.array,
  currentTags: PropTypes.array,
  module: PropTypes.string,
}

const enharce = compose(withI18n)

export default enharce(ModalChangeTags)
